import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import Home from "@/pages/Home";
import CorporateHome from "@/pages/CorporateHome";
import PemeReview from "@/pages/PemeReview";
import ClinicAudit from "@/pages/ClinicAudit";
import CorporateWellness from "@/pages/CorporateWellness";
import WhyMedVerify from "@/pages/WhyMedVerify";
import AboutUs from "@/pages/AboutUs";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.lenis = lenis;
    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
    return () => lenis.destroy();
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<CorporateHome />} />
        <Route path="/maritime-home" element={<Home />} />
        <Route path="/peme-review" element={<PemeReview />} />
        <Route path="/clinic-audit" element={<ClinicAudit />} />
        <Route path="/corporate-wellness" element={<CorporateWellness />} />
        <Route path="/why-med-verify" element={<WhyMedVerify />} />
        <Route path="/about-us" element={<AboutUs />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
